module.exports = __webpack_public_path__ + "static/img/yu4.b0abde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/yu4.png
// module id = 0qED
// module chunks = 0